import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseReviewList.module.scss'

import MyhouseReviewItem from '@Components/atoms/MyhouseReviewListItem'
import MyHouseReviewSummaryResponse from '@Types/entities/MyHouseReviewSummaryResponse'

const cx = className.bind(style)

type Props = {
  list?: any
}

const MyhouseReviewList: React.FC<Props> = ({ list }: Props) => {
  return (
    <div className={cx('myhouse_resident_list')} role="tabpanel" aria-labelledby="tabCategory">
      {list.map((review: MyHouseReviewSummaryResponse, index: number) => (
        <div key={`review_${index}`} className={cx('myhouse_resident_item')}>
          <MyhouseReviewItem {...review} />
        </div>
      ))}
    </div>
  )
}

export default MyhouseReviewList
